import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { getMsalInstance } from '../auth/msalInstance';
import { apiClaimsUser } from '../auth/azure-ad-b2c';
import { getTenantLocalStorage } from './config';

const securePost = async (authToken, tenant) => {
   if (!authToken) return;
   const myHeaders = new Headers();
   myHeaders.append("Content-Type", "application/json");
   myHeaders.append("Authorization", "Basic ZXBzX3NzcF9hcGk6U3VtbWVyQDIwMTgj");

   const raw = JSON.stringify({
      "givenName": authToken?.idTokenClaims?.given_name,
      "surname": authToken?.idTokenClaims?.family_name,
      "displayName": "string",
      "email": authToken?.idTokenClaims?.emails[0],
      "objectId": tenant?.uiClientId,
      "tenantId": tenant?.id
   });

   const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
   };

   const response = await fetch(apiClaimsUser, requestOptions);

   if (response.ok) return response.json()
   return null
}

export const getTanantId = async () => {
   const { activeAccount } = await getMsalInstance();
   const tenant = getTenantLocalStorage();
   const ssoCondition = /sso/g.test(tenant?.id.toLowerCase());
   const ssoClaimsApiToken = ssoCondition ? await securePost(activeAccount, tenant) : null;

   return tenant?.id
}

export const getToken = async (scopes) => {
   const { msalInstance, activeAccount } = await getMsalInstance();
   if (!activeAccount) {
      throw Error('No active account! Verify a user has been signed in and setActiveAccount has been called.');
   }

   const response = await msalInstance.acquireTokenSilent({
      account: activeAccount,
      scopes: scopes
   });

   return response.accessToken;
};

export const validateAndAcquireIfRequired = async (scopes) => {
   const { msalInstance, activeAccount } = await getMsalInstance();

   if (!activeAccount) {
      throw Error('No active account! Verify a user has been signed in and setActiveAccount has been called.');
   }

   const response = await msalInstance.acquireTokenSilent({
      account: activeAccount,
      scopes: scopes,
      forceRefresh: false
   }).catch(error => {
      if (error instanceof InteractionRequiredAuthError) {
         console.log('InteractionRequiredAuthError, try msalInstance.acquireTokenRedirect', error);
         // fallback to interaction when silent call fails
         return msalInstance.acquireTokenRedirect({
            scopes: scopes,
            loginHint: activeAccount.username
         })
      }
   })

   //return response.accessToken;
};

export const getTenantURL = async () => {
   const tenantUrl = await getTanantId();
   return tenantUrl
};

export const getUserEmailId = async () => {
   const { activeAccount: { idTokenClaims: { emails } } } = await getMsalInstance();
   return (Array.isArray(emails) ? emails[0] : emails).toLowerCase();
}
